// Smart API base URL resolver:
// - In production browsers served from voltusta.com (or any custom domain),
//   use the same origin to avoid cross-origin CORS+credentials issues.
// - In preview/dev (localhost:3000 → backend at 8001), use REACT_APP_BACKEND_URL.
export const getApiBase = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    // Production custom domains and Emergent production host serve frontend+backend same-origin
    if (
      host === 'voltusta.com' ||
      host === 'www.voltusta.com' ||
      host.endsWith('.emergent.host')
    ) {
      return `${window.location.origin}/api`;
    }
  }
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export const API = getApiBase();
